const getMuiFormControl = () => ({
  defaultProps: {
    fullWidth: true,
  },
  styleOverrides: {
    root: {
      // Fallback selector for Select container
      '&.MuiFormControl-root': {
        '& .MuiSelect-root': {
          width: '100% ',
        },
      },
    },
    fullWidth: {
      width: '100%',
      minWidth: '100%',
    },
  },
});
export default getMuiFormControl;
